export const textfield_sx = {
    '& .MuiInputBase-root': {
        borderRadius: "12px", // Custom border radius
        maxHeight: "50px",
        borderColor: '#007814',
        
        
    },

    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#758278',
    },
}